import { render, staticRenderFns } from "./DetailCta.vue?vue&type=template&id=7acb9ef7"
import script from "./DetailCta.vue?vue&type=script&lang=js"
export * from "./DetailCta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports